<template>
    <at-modal v-model="show" :width="getWinWidth()" :class="'foolscreen'">
        <div slot="header" style="text-align:center;">
            <span>{{getPage(page,'name', cat)}}</span>
        </div>
        <breadcrumb style="padding-bottom: 5px"></breadcrumb>
        <div v-if="!cat" :style="`text-align:justify; color: #3f536e; overflow-y: auto; height: calc(${height}); padding-right: 15px; margin-right: -5px;`" v-html="content"/>
        <div v-else :style="`text-align:justify; overflow-y: auto; height: calc(${height}); padding-right: 15px; margin-right: -5px;`">
            <p style="padding-bottom: 5px">{{ content?.description }}</p>
            <b v-if="content?.subcats && content.subcats.length > 0">Категории раздела</b>
            <ul style="padding-bottom: 5px">
                <li v-for="(sCat, sCatId) in content.subcats" :key="sCatId">
                    <a :href="`#/cat/${sCat}`">{{ getPage(sCat,'name', true) }}</a>
                </li>
            </ul>
            <b v-if="content?.pages && content?.pages.length > 0">Доступные статьи</b>
            <ul>
                <li v-for="(sPage, sPageId) in content?.pages" :key="sPageId">
                    <a :href="`#/page/${sPage}`">{{ getPage(sPage,'name', false) }}</a>
                </li>
            </ul>
        </div>
        <div slot="footer">
            <div style="float: left;">
                <!-- <at-switch v-model="foolscreen" @change="val=>foolscreen = val"></at-switch> на весь экран -->
            </div>
            <at-button style="width:20%;" type="success" @click="show = false">Закрыть</at-button>
        </div>
    </at-modal>
</template>

<script>
import Breadcrumb from './BreadcrumbComponent.vue'

export default {
    components: {
        Breadcrumb
    },
    computed: {
        page() {
            return this.$route.params.id
        },
        cat() {
            return this.$route.params.type == 'cat'
        },
        content() {
            return this.getPage(this.page, 'content', this.cat)
        },
        show: {
            get() {
                return (this.showPage && this.$route.params.type != 'point')
            },
            set(val) {
                this.showPage = val
                if (!val) {
                    this.foolscreen = false
                    this.$router.push('/')
                }
            }
        },
        foolscreen: {
            get() {
                return window.$('.at-modal').hasClass('foolscreen')
            },
            set(val) {
                if(val) {
                    window.$('.at-modal').addClass('foolscreen')
                    window.$('.at-modal__footer').addClass('foolscreen__foot')
                    this.height = "100vh - 150px"
                } else {
                    window.$('.at-modal').removeClass('foolscreen')
                    window.$('.at-modal__footer').removeClass('foolscreen__foot')
                    this.height = "60vh"
                }
            }
        }
    },
    data: () => ({
        showPage: true,
        height: "60vh"
    }),
    methods: {
        getPage(id, part, cat) {
            switch (cat) {
                case true:
                    var page = this.$store.getters.getCat(id)
                    if(page) {
                        if(part == "content" && page.content == "")
                            this.$store.dispatch('getCat', { page })
                        return page[part]
                    }
                    break;
                case false:
                    var p = this.$store.getters.getPage(id)
                    if(p) {
                        if(part == "content" && p.content == "")
                            this.$store.dispatch('getPage', { page: p })
                        return p[part]
                    }
                    break;
            }

            if (this.page == id) {
                this.$Message.error('Вызываемая страница не существует!')
                this.show = false
            }
            return undefined
        },
        getWinWidth() {
            return Math.min(Math.floor(document.documentElement.clientWidth * 0.8), 600)
        },
    }
};
</script>
<style>
.foolscreen {
    height: 100% !important;
    width: 100% !important;
    top: 0;
}

.foolscreen__foot {
    position: fixed;
    bottom: 20px;
    background-color: white;
    width: calc(100% - 202px);
}

.at-modal__body img {
    max-width: 100%;
}
</style>
